import React, { useState, useEffect } from "react";
import { Spin } from 'antd';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { apiConfig, constantConfig } from 'web-common';
import HomeCarousel from './component/HomeCarousel';
import { request } from '../../util/request';
import { BannerPoster } from '../common/BannerPoster';
import './style/index.less';




const { WEBSITE_PATHS } = constantConfig;
const { GLOBAL_WEBSITE_URL } = apiConfig;


// 新闻-固定分类id
const NEWS_FIXED_KEY = {
	JZFZ_DYNAS: '1864881116153479170', // 基准动态
	JZFZ_AWARD: '1867511605175615489', // 荣誉奖项
};



/**
 * 首页
 */
const Home = () => {

	const history = useHistory();

	const { isMobile } = useSelector((state: any) => state.reducer);

	const [loading, setLoading] = useState<boolean>(false);
	// 轮播图列表-PC
	const [pcBanners, setPcBanners] = useState<string[]>([]);
	// 轮播图列表-MOBILE
	const [mobileBanners, setMobileBanners] = useState<string[]>([]);
	// 轮播间隔,速率
	const [speed, setSpeed] = useState<number>(0);


	useEffect(() => {
		queryHomeData();
	}, []);


	/**
	 * 查询首页数据
	 */
	const queryHomeData = () => {
		setLoading(true);
		request(
			'/index-setting/get', 
			{}, 
			{ method: 'get', baseURL: GLOBAL_WEBSITE_URL }
		).then((res) => {
			const { carouselInterval, images, mobileImages, pkid } = res.data || {};
			setSpeed(carouselInterval || 2);
			if (Array.isArray(images)) {
				setPcBanners(images);
			}
			if (Array.isArray(mobileImages)) {
				setMobileBanners(mobileImages);
			}
		}).finally(() => {
			setLoading(false);
		});
	};


	/**
	 * PC home页面
	 * @returns 
	 */
	const PCHome = () => (
		<div className="company-home-wrapper" style={{height: window.innerHeight}}>
			{/* PC端轮播区域高度, 屏幕高度 - 页头的高度 */}
			<div className="home-banner h pr">
				{/* 轮播 */}
				<HomeCarousel data={pcBanners} speed={speed} />

				{/* 轮播左侧悬浮内容 */}
				<div className="slider-left-info">
					<div>
						<div className="mb16 crp" onClick={() => history.replace(`${WEBSITE_PATHS.news}?menuId=${NEWS_FIXED_KEY.JZFZ_DYNAS}`)}>
							<div className="f22 lh20">动态</div>
							<div className="f14">NEWS</div>
						</div>
						<div className="mb16 crp" onClick={() => history.replace(WEBSITE_PATHS.product)}>
							<div className="f22 lh20">作品</div>
							<div className="f14">PROJECTS</div>
						</div>
						<div className="mb16 crp" onClick={() => history.replace(`${WEBSITE_PATHS.news}?menuId=${NEWS_FIXED_KEY.JZFZ_AWARD}`)}>
							<div className="f22 lh20">奖项</div>
							<div className="f14">AWARDS</div>
						</div>
						<div className="crp" onClick={() => history.replace(WEBSITE_PATHS.contactUs)}>
							<div className="f22 lh20">联系</div>
							<div className="f14">CONTACTS</div>
						</div>
					</div>
				</div>
				
				{/* 轮播右侧悬浮内容 */}
				<div className="slider-right-info">
					<BannerPoster align="tr" />
				</div>
			</div>
		</div>
	);


	/**
	 * mobile home page
	 */
	const MobileHome = () => (
		<div className="company-home-mobile-wrapper" style={{height: window.innerHeight}}>
			<div className="home-banner h pr">
				{/* 轮播 */}
				<HomeCarousel data={mobileBanners} speed={speed} />

				{/* 轮播左侧悬浮内容 */}
				<div className="slider-left-info">
					<div>
						<div className="mb16 crp" onClick={() => history.replace(`${WEBSITE_PATHS.news}?menuId=${NEWS_FIXED_KEY.JZFZ_DYNAS}`)}>
							<div className="f22 lh20">动态</div>
							<div className="f14">NEWS</div>
						</div>
						<div className="mb16 crp" onClick={() => history.replace(WEBSITE_PATHS.product)}>
							<div className="f22 lh20">作品</div>
							<div className="f14">PROJECTS</div>
						</div>
						<div className="mb16 crp" onClick={() => history.replace(`${WEBSITE_PATHS.news}?menuId=${NEWS_FIXED_KEY.JZFZ_AWARD}`)}>
							<div className="f22 lh20">奖项</div>
							<div className="f14">AWARDS</div>
						</div>
						<div className="mb16 crp" onClick={() => history.replace(WEBSITE_PATHS.contactUs)}>
							<div className="f22 lh20">联系</div>
							<div className="f14">CONTACTS</div>
						</div>
					</div>
				</div>
				
				{/* 轮播右侧悬浮内容 */}
				<div className="slider-right-info">
					<BannerPoster align="tr" />
				</div>
				
			</div>
		</div>
	);


	return (
		<>
			{isMobile ? <MobileHome /> : <PCHome />}
			<Spin spinning={loading} />
		</>
	);
}


export default Home;
